import React from 'react';
export const ChildrenWithCustomProps = ({ children = null, props }) => {
    if (!children)
        return;
    return (React.createElement(React.Fragment, null, React.Children.map(children, (child) => {
        if (React.isValidElement(child)) {
            return React.cloneElement(child, props);
        }
        return null;
    })));
};
